import * as I18n from 'circe/I18n';
import { NAME as APP_NAME, ROUTES as PARENT_ROUTES } from '../constants';

export const NAME = `${APP_NAME}/ITINERARY_STATUS/VIEW`;

export const REDUCER_NAME = 'view';

export const ROUTES = {
  ROOT: `${PARENT_ROUTES.ROOT}/:itineraryId`,
};
export const ALLOWED_MIME_TYPES = 'image/*,application/pdf';

export const EVENT_TYPES = [
  { value: 'SHIPMENT_PICKUP', label: I18n.str('shipmentPickup', 'Shipment Pickup') },
  { value: 'SHIPMENT_DELIVERY', label: I18n.str('shipmentDelivery', 'Shipment Delivery') },
];

export const BAYAN_REASON_CODES = [
  {
    code: 1,
    value: 'Waybill Cancellation',
    label: I18n.str('waybillCancellation', 'Waybill cancellation'),
  },
  {
    code: 2,
    value: 'The recipient refused to receive it',
    label: I18n.str('refusedToReceive', 'The recipient refused to receive it'),
  },
  { code: 3, value: 'Due the damage', label: I18n.str('dueToDamage', 'Due the damage') },
  {
    code: 4,
    value: 'The recipient refused to receive it due to the theft',
    label: I18n.str(
      'refusedToReceiveDueToTheft',
      'The recipient refused to receive it due to the theft',
    ),
  },
];
export const DROPOFF_STOP = 'DROPOFF';

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/drivers`;
